const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content"];

export function captureUtm() {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) found[k] = v.slice(0, 200);
    });
    if (Object.keys(found).length) {
      const existing = JSON.parse(sessionStorage.getItem("vc_utm") || "{}");
      sessionStorage.setItem("vc_utm", JSON.stringify({ ...existing, ...found }));
    }
  } catch (e) { /* storage unavailable */ }
}

export function getUtm() {
  try {
    return JSON.parse(sessionStorage.getItem("vc_utm") || "{}");
  } catch (e) {
    return {};
  }
}

export function track(type, extra = {}) {
  try {
    fetch(`${API}/analytics/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        type,
        path: window.location.pathname,
        referrer: document.referrer || "",
        ...getUtm(),
        ...extra,
      }),
    }).catch(() => {});
  } catch (e) { /* never block UX on analytics */ }
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}
